import { HEADLINE_FONTS } from "@/constants/fonts";

const loaded = new Set(["Outfit", "Syne"]); // already preloaded in index.html

// Dynamically injects a Google Fonts <link> for the given headline font id, once per font.
export function loadHeadlineFont(fontId) {
  if (!fontId || loaded.has(fontId)) return;
  const entry = HEADLINE_FONTS.find((f) => f.id === fontId);
  if (!entry) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${entry.googleParam}&display=swap`;
  document.head.appendChild(link);
  loaded.add(fontId);
}
